import { FC, useEffect } from 'react';
import { useFormState, useWatch } from 'react-hook-form';

import { intersects } from 'radash';

import { diff } from 'helpers/diff';

import { useSubmitForm } from './Form';

type Props = {
    instant?: string[];
    saveOnFields?: string[]; // if passed, only autosave if these fields change
};

const AutoSave: FC<Props> = ({ instant = [], saveOnFields = [] }) => {
    const values = useWatch();
    const { defaultValues } = useFormState();

    const { submit, debounced } = useSubmitForm();

    useEffect(() => {
        if (!defaultValues) {
            return console.error('Cannot autosave without default values!');
        }

        const { hasUpdates, updates, hasDeletes, deletes } = diff(defaultValues, values);
        const updated = hasUpdates || hasDeletes;

        if (!updated) {
            return;
        }

        const keys = Object.keys({
            ...updates,
            ...deletes,
        });

        if (saveOnFields.length && !intersects(saveOnFields, keys)) {
            return;
        }

        if (intersects(instant, keys)) {
            submit().then();
        } else {
            debounced();
        }
    }, [values]);

    return null;
};

export { AutoSave };
